module.exports = __webpack_public_path__ + "static/media/cubes.9868ed5c.svg";